/*eslint-disable camelcase*/
// https://github.com/frontend-collective/react-sortable-tree/blob/master/src/utils/classnames.js
function classnames (...classes) {
    return classes.filter(Boolean).join(' ');
}

// svg for material icons: http://materialdesignicons.com/
// https://css-tricks.com/using-svg/
const DragIndicatorSVG = 'M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z';

// #24A5E9 => %2324A5E9
const HexEscape = hexcolor => hexcolor.replace('#', '%23');

const NormalNode = node => {
    const {
        nodes,
        root,
        hidden,
        title,
        groupable,
        fivetuple,
        sortable,
        select,
        country,
        field,
        indexed,
        tableHidden,
        jsonHidden,
        last_seen_in_index,
        last_seen,
        hide,
        source,
        name,
        align,
        gator,
        hint,
        jsonSort,
        props,
        valueType,
        ...rest
    } = (node || {});
    return rest;
};

export {
    DragIndicatorSVG,
    HexEscape,
    NormalNode,
    classnames as default
};
